import { create } from "zustand";
import { fetchShadowEmployeesListService } from "../services/shadowEmployeeListStoreService";

export const useShadowEmployeeStore = create((set) => ({
  shadowEmployeeList: [],
  loading: false,
  fetchShadowEmployees: async (projectId) => {
    await fetchShadowEmployeesListService(set, projectId);
  },
  setShadowEmployeeList: (list) => set({ shadowEmployeeList: list }),
}));
